import { http } from 'utils'
import { set } from 'lodash'
import { SET_OBJECTIVES, ADD_OBJECTIVE, DELETE_OBJECTIVE, ADD_ACTION, DELETE_ACTION, SET_PROPERTY } from 'vx/mutations'

export const initialActionState = () => ({
  description: null,
  start_date: null,
  end_date: null
})

export const initialDevelopmentObjectiveState = () => ({
  description: null,
  education: false,
  experience: false,
  exposure: false,
  actions: [
    initialActionState()
  ]
})

const state = {
  objectives: [
    initialDevelopmentObjectiveState()
  ]
}

const actions = {
  async getDevelopmentObjectives ({ commit, rootState }) {
    const placement = rootState.placements.placement

    const response = await http.get(`/graduates/${placement.graduate_id}/placements/${placement.id}/start-component/development`)

    commit(SET_OBJECTIVES, response.data.data)

    return response
  },

  async storeDevelopmentObjectives ({ commit, rootState }, payload) {
    const placement = rootState.placements.placement

    const response = await http.post(`/graduates/${placement.graduate_id}/placements/${placement.id}/start-component/development`, payload)

    commit(SET_OBJECTIVES, response.data.data)

    return response
  },

  setActionProperty ({ commit }, { objectiveIndex, actionIndex, property, value }) {
    commit(SET_PROPERTY, {
      objectiveIndex,
      property: `actions.${actionIndex}.${property}`,
      value
    })
  },

  setObjectiveProperty ({ commit }, { objectiveIndex, property, value }) {
    commit(SET_PROPERTY, { objectiveIndex, property, value })
  },

  addBlankObjective ({ commit }) {
    commit(ADD_OBJECTIVE, initialDevelopmentObjectiveState())
  },

  deleteObjective ({ commit }, objectiveIndex) {
    commit(DELETE_OBJECTIVE, objectiveIndex)
  },

  addBlankAction ({ commit }, objectiveIndex) {
    commit(ADD_ACTION, { objectiveIndex, action: initialActionState() })
  },

  deleteAction ({ commit }, { objectiveIndex, actionIndex }) {
    commit(DELETE_ACTION, { objectiveIndex, actionIndex })
  }
}

const mutations = {
  [SET_OBJECTIVES] (state, objectives) {
    if (objectives.length === 0) {
      state.objectives = [initialDevelopmentObjectiveState()]
    } else {
      state.objectives = objectives
    }
  },

  [SET_PROPERTY] (state, { objectiveIndex, property, value }) {
    set(state.objectives[objectiveIndex], property, value)
  },

  [ADD_OBJECTIVE] (state, objective) {
    state.objectives.push(objective)
  },

  [DELETE_OBJECTIVE] (state, objectiveIndex) {
    state.objectives.splice(objectiveIndex, 1)
  },

  [ADD_ACTION] (state, { objectiveIndex, action }) {
    state.objectives[objectiveIndex].actions.push(action)
  },

  [DELETE_ACTION] (state, { objectiveIndex, actionIndex }) {
    state.objectives[objectiveIndex].actions.splice(actionIndex, 1)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
